import { useEffect } from 'react'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { removeParamsFromQuery, urlWithParams } from '@marketplace-web/shared/url-util'

import { PromoAfterItemUpload } from '../containers/PromoAfterItemUploadContext'

const usePromoShown = (currentPromotion: PromoAfterItemUpload | null) => {
  const { replaceHistoryState, relativeUrl, urlQuery, searchParams } = useBrowserNavigation()

  useEffect(() => {
    if (!currentPromotion || currentPromotion === PromoAfterItemUpload.Empty) {
      const urlWithoutParam = removeParamsFromQuery(relativeUrl, urlQuery, ['promo_shown'])
      replaceHistoryState(urlWithoutParam)

      return
    }

    const updatedUrl = urlWithParams(relativeUrl, {
      ...searchParams,
      promo_shown: true,
    })

    replaceHistoryState(updatedUrl)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPromotion])
}

export default usePromoShown
